import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /^imp|sjv\.io|pxf\.io/.test(hostname)
export const compactTracking = true

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.trackingId) {
    url.searchParams.set('subId1', params.trackingId)
    url.searchParams.delete('subId2')
    url.searchParams.delete('subId3')
    url.searchParams.delete('sharedId')
    return
  }
  if (params.content) {
    url.searchParams.set('subId1', params.content)
  }
  url.searchParams.set('subId2', params.pathname)
  url.searchParams.set('subId3', params.utmSearch)
  url.searchParams.set('sharedId', params.term)
}
